import { useQuery } from '@tanstack/react-query';
import axios from '~/utils/axios';

interface FailedRebillsResponse {
  subscriptionIds: number[];
}

export const useFailedRebills = () => {
  return useQuery<number[]>({
    queryKey: ['failedRebills'],
    queryFn: async () => {
      const response = await axios.get<FailedRebillsResponse>('/me/billing-v2/failedRebills');
      return response.data.subscriptionIds ?? [];
    },
    // Fail safe — don't block resets if the request errors
    placeholderData: [],
    staleTime: 60000,
    refetchOnWindowFocus: true,
  });
};
